"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fa_1 = require("react-icons/fa");
const style_1 = require("./style");
const Button_1 = __importDefault(require("@/components/Button"));
function Prompt({ saveChangesButtonLabel, discardChangesButtonLabel, onSaveChanges, onDiscardChanges, shouldShowPrompt, children, isSaveButtonDisabled = false, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(style_1.PromptWrapper, { shouldShowPrompt: shouldShowPrompt },
            react_1.default.createElement(style_1.PromptContent, null,
                children,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Button_1.default, { leftLabel: fa_1.FaTimes, size: "medium", variant: "outlined", color: "secondary", leftLabelSize: 16, label: discardChangesButtonLabel, onClick: onDiscardChanges }),
                    react_1.default.createElement(Button_1.default, { size: "medium", color: "primary", variant: "contained", label: saveChangesButtonLabel, rightLabel: fa_1.FaCheck, rightLabelSize: 16, disabled: isSaveButtonDisabled, onClick: onSaveChanges }))))));
}
exports.default = Prompt;
